import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <h3 className="empty-state-title">{title || 'No skills found'}</h3>
      <p className="empty-state-description">
        {description || 'Try adjusting your search or filters.'}
      </p>
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
